import React from 'react'
import ReactTable, { RowInfo, SortingRule, TableProps as OriginalTableProps } from 'react-table'
import { Waypoint } from 'react-waypoint'
import Loader from '../Loader/Loader'

import 'react-table/react-table.css'
import './Table.scss'

export interface ITableProps extends Partial<OriginalTableProps<any>> {
  /**
   * Is table loading more data
   */
  isLoading?: boolean
  /**
   * Callback when user scrolls to the bottom of the table
   */
  fetchMoreData?(): void
  handleSortedChange?(newSorted: SortingRule[]): void
}

export class Table extends React.Component<ITableProps> {
  state = {
    expanded: { 0: false },
  }

  static defaultProps: ITableProps = {
    defaultSortDesc: true,
    resizable: false,
    showPageJump: false,
    showPageSizeOptions: false,
    showPagination: false,
  }

  static rankBEM(max: number) {
    const classArray = ['rt-td--rank']

    if (max < 10) {
      classArray.push('rt-td--rank-xs')
    }

    if (max >= 10 && max < 100) {
      classArray.push('rt-td--rank-sm')
    }

    return classArray.join(' ')
  }

  handleWaypoint = (position: Waypoint.CallbackArgs) => {
    const { isLoading, fetchMoreData } = this.props

    if (!isLoading && fetchMoreData && position.currentPosition === 'inside') {
      fetchMoreData()
    }
  }

  getExpanded = () => {
    return this.state.expanded
  }

  setExpanded = (e: any) => {
    this.setState({
      expanded: e,
    })
  }

  render() {
    const { data, isLoading, fetchMoreData, handleSortedChange, ...rest } = this.props

    const getClassName = (
      {
        original: {
          isCompleted,
          isSelf,
          isBeforeSelf,
          isSeparatorForAbove,
          isSeparatorForBelow,
          accentColor,
          alignRight,
        },
      } = {
        original: {
          isCompleted: false,
          isSelf: false,
          isBeforeSelf: false,
          isSeparatorForAbove: false,
          isSeparatorForBelow: false,
          accentColor: undefined,
          alignRight: false,
        },
      },
    ) => {
      const classArray = []

      if (isBeforeSelf) {
        classArray.push('rt-tr--before-self')
      }

      if (isSelf) {
        classArray.push('rt-tr--self')
      }

      if (isCompleted) {
        classArray.push('rt-tr--active')
      }

      if (isSeparatorForAbove) {
        classArray.push('rt-tr--separator-for-above')
      }

      if (isSeparatorForBelow) {
        classArray.push('rt-tr--separator-for-below')
      }

      if (accentColor) {
        classArray.push(`rt-tr--accent-${accentColor}`)
      }

      if (alignRight) {
        classArray.push('rt-tr--align-right')
      }

      return classArray.join(' ')
    }

    const getTrProps = (state: any, rowInfo: RowInfo | undefined) => ({ className: getClassName(rowInfo) })

    return (
      <div className="table">
        {data && data.length ? (
          <>
            <ReactTable
              {...rest}
              getTrProps={getTrProps}
              data={data}
              pageSize={data.length}
              onSortedChange={handleSortedChange}
              expanded={this.getExpanded()}
              onExpandedChange={(e) => {
                this.setExpanded(e)
              }}
            />
            {fetchMoreData && !isLoading && <Waypoint onEnter={this.handleWaypoint} bottomOffset={-2500} />}
          </>
        ) : null}
        {(!data || !data.length || fetchMoreData) && isLoading && <Loader />}
      </div>
    )
  }
}
